import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const MaskLine = ({ children, delay = 0, as: Tag = "span" }) => {
  const reduce = useReducedMotion();
  return (
    <span className="block overflow-hidden pb-[0.3em] -mb-[0.3em]">
      <motion.span
        className="block will-change-transform"
        initial={reduce ? false : { y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        <Tag>{children}</Tag>
      </motion.span>
    </span>
  );
};
